// extracted by mini-css-extract-plugin
export var backgroundImage = "why-outsource-java-module--background-image--WgD17";
export var description = "why-outsource-java-module--description--a8xPZ";
export var descriptionContainer = "why-outsource-java-module--description-container--bNrnu";
export var innerWrapper = "why-outsource-java-module--inner-wrapper--WU+10";
export var leftColumn = "why-outsource-java-module--left-column--z5KDl";
export var outerWrapper = "why-outsource-java-module--outer-wrapper--dKQj1";
export var rightColumn = "why-outsource-java-module--right-column--RUyqB";
export var rightDescription = "why-outsource-java-module--right-description--zULJv";
export var title = "why-outsource-java-module--title--jfEXw";
export var titleAndDescriptionContainer = "why-outsource-java-module--title-and-description-container--D+W7M";
export var usagesContainer = "why-outsource-java-module--usages-container--i8E8p";